const CustomLevelSvg = ({
  level,
  width = 28,
  height = 30,
}: {
  level: number;
  width?: number;
  height?: number;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 28 30"
    fill="none"
  >
    <g filter="url(#filter0_i_17683_2023)">
      <path
        d="M10.0882 1.59846C12.4584 0.0240096 15.5416 0.024008 17.9118 1.59846L23.9625 5.61771C25.8045 6.8413 26.9679 8.85634 27.1065 11.0634L27.562 18.3131C27.7404 21.153 26.1988 23.823 23.6502 25.0885L17.1441 28.3189C15.1634 29.3024 12.8366 29.3024 10.8559 28.3189L4.34983 25.0885C1.8012 23.823 0.259626 21.153 0.43803 18.3131L0.893457 11.0634C1.03211 8.85634 2.19548 6.84131 4.03752 5.61771L10.0882 1.59846Z"
        fill="#242366"
      />
    </g>
    <path
      d="M10.6416 2.43164C12.613 1.12213 15.1587 1.08092 17.166 2.30859L17.3584 2.43164L23.4092 6.4502C24.8917 7.43499 25.8625 9.01737 26.0762 10.7725L26.1084 11.126L26.5635 18.376C26.7118 20.7379 25.475 22.9634 23.4082 24.0879L23.2051 24.1924L16.6992 27.4229C15.105 28.2144 13.2499 28.2639 11.623 27.5713L11.3008 27.4229L4.79492 24.1924C2.67506 23.1398 1.36609 20.9558 1.42578 18.6035L1.43652 18.376L1.8916 11.126C2.00322 9.34965 2.88763 7.71786 4.30078 6.65527L4.59082 6.4502L10.6416 2.43164Z"
      stroke="url(#paint0_linear_17683_2023)"
      strokeWidth="2"
    />
    <text
      x="14"
      y="21"
      textAnchor="middle"
      fill="#F2F2F2"
      fontSize="16"
      fontWeight="700"
      fontFamily="Cabin"
    >
      {level}
    </text>
    <defs>
      <filter
        id="filter0_i_17683_2023"
        x="0.423828"
        y="0.417603"
        width="27.1523"
        height="30.1273"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.48837" />
        <feGaussianBlur stdDeviation="5.02326" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0597531 0 0 0 0 0.0574266 0 0 0 0 0.173756 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_17683_2023"
        />
      </filter>
      <linearGradient
        id="paint0_linear_17683_2023"
        x1="14"
        y1="-1"
        x2="14"
        y2="31"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9B3DE" />
        <stop offset="1" stopColor="#4846CC" />
      </linearGradient>
    </defs>
  </svg>
);

export default CustomLevelSvg;
